// Server sanalari bilan ishlash (umumiy util).
// Backend `date-time` maydonlarini vaqt mintaqasisiz (masalan "2026-09-29T12:56:51.505119") qaytaradi —
// bunday qiymat UTC deb o'qiladi. Ekranda Toshkent vaqti ko'rsatiladi.

const HAS_ZONE = /(Z|[+-]\d{2}:?\d{2})$/i;

// Natija: millisekund (number) yoki null.
export function parseServerDate(value) {
  if (value === null || value === undefined || value === '') return null;
  if (typeof value === 'number') return Number.isFinite(value) ? value : null;
  if (typeof value !== 'string') return null;

  let text = value.trim();
  if (!text) return null;
  // "2026-10-02 10:00:00" → "2026-10-02T10:00:00"
  text = text.replace(/^(\d{4}-\d{2}-\d{2})[ ](\d)/, '$1T$2');
  // Kasr soniyalarni 3 xonagacha qisqartirish (".123456" → ".123")
  text = text.replace(/(\.\d{3})\d+/, '$1');
  // Faqat sana bo'lsa ham UTC
  if (/^\d{4}-\d{2}-\d{2}$/.test(text)) text += 'T00:00:00';
  if (!HAS_ZONE.test(text)) text += 'Z';

  const ms = Date.parse(text);
  return Number.isNaN(ms) ? null : ms;
}

export const DISPLAY_TIME_ZONE = 'Asia/Tashkent';

const PARTS_FORMAT = new Intl.DateTimeFormat('en-GB', {
  timeZone: DISPLAY_TIME_ZONE,
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  hourCycle: 'h23',
});

function tashkentParts(value) {
  const ms = parseServerDate(value);
  if (ms === null) return null;
  return Object.fromEntries(PARTS_FORMAT.formatToParts(new Date(ms)).map((part) => [part.type, part.value]));
}

// "2026-09-29T12:56:51.505119" (UTC) → "29.09.2026, 17:56"; bo'sh yoki noto'g'ri qiymat → null
export function formatServerDateTime(value) {
  const parts = tashkentParts(value);
  return parts ? `${parts.day}.${parts.month}.${parts.year}, ${parts.hour}:${parts.minute}` : null;
}

// "2026-09-29T21:30:00" (UTC) → "30.09.2026" (Toshkent kuni); bo'sh yoki noto'g'ri qiymat → null
export function formatServerDate(value) {
  const parts = tashkentParts(value);
  return parts ? `${parts.day}.${parts.month}.${parts.year}` : null;
}
